import { ChangeDetectionStrategy, Component, inject, input, model, OnInit, output } from '@angular/core';
import { ReactiveFormsModule, FormControl, FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { Dialog } from 'primeng/dialog';
import { InputTextModule } from 'primeng/inputtext';
import { MessageModule } from 'primeng/message';
import { ToggleSwitch } from 'primeng/toggleswitch';
import { CommonModule } from '@angular/common';
import { TipoConvenio } from '../../banco-conta-convenio';
import { CanDirective } from '@/core/permissions/can.directive';
import { PERMISSOES } from '@/core/permissions/permissoes.catalog';

import { DialogoPadraoDirective } from '@/shared/components/layout/dialogo-padrao/dialogo-padrao.directive';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-tipo-convenio-detalhe',
    standalone: true,
    imports: [DialogoPadraoDirective, CommonModule, ReactiveFormsModule, ButtonModule, Dialog, InputTextModule, MessageModule, ToggleSwitch, CanDirective],
    templateUrl: './tipo-convenio-detalhe.html',
    styleUrl: './tipo-convenio-detalhe.scss'
})
/** Modal de novo/edição de tipo de convênio. */
export class TipoConvenioDetalhe implements OnInit {
    protected readonly roleBancosEditar = PERMISSOES.configuracoes.bancos.editar;

    private readonly fb = inject(FormBuilder);

    convenio = input<TipoConvenio | null>(null);
    showDialog = model.required<boolean>();
    salvo = output<TipoConvenio>();

    convenioForm!: FormGroup<{ sigla: FormControl<string>; wsdlBoleto: FormControl<boolean> }>;
    formSubmitted = false;

    ngOnInit(): void {
        this.convenioForm = this.fb.nonNullable.group({
            sigla: ['', [Validators.required]],
            wsdlBoleto: [false]
        });
    }

    onDialogShow(): void {
        this.formSubmitted = false;
        const currentConvenio = this.convenio();
        if (currentConvenio) {
            this.convenioForm.patchValue({
                sigla: currentConvenio.sigla,
                wsdlBoleto: currentConvenio.wsdlBoleto
            });
        } else {
            this.convenioForm.reset({ wsdlBoleto: false });
        }
    }

    hideDialog(): void {
        this.showDialog.set(false);
    }

    isInvalid(controlName: string): boolean {
        const control = this.convenioForm.get(controlName);
        return (control?.invalid && (control?.dirty || control?.touched || this.formSubmitted)) || false;
    }

    salvar(): void {
        this.formSubmitted = true;
        if (this.convenioForm.invalid) {
            return;
        }

        const formValue = this.convenioForm.getRawValue();
        const convenioSalvo: TipoConvenio = {
            ...(this.convenio() || { id: '', parentId: '', usuario: '' }),
            sigla: formValue.sigla,
            wsdlBoleto: formValue.wsdlBoleto
        };

        this.salvo.emit(convenioSalvo);
        this.hideDialog();
    }
}
